import { Action as ReduxAction } from 'redux';

namespace AutoSavingAction {
  export enum ActionType {
    ENABLE = 'AUTO_SAVING_ENABLE',
    FINISH_PROCESS = 'AUTO_SAVING_FINISH_PROCESS',
  }

  interface EnableAction extends ReduxAction {
    type: ActionType.ENABLE;
  }

  interface FinishProcessAction extends ReduxAction {
    type: ActionType.FINISH_PROCESS;
  }

  export const enable = (): EnableAction => ({ type: ActionType.ENABLE });
  export const finishProcess = (): FinishProcessAction => ({ type: ActionType.FINISH_PROCESS });

  export type Action = EnableAction | FinishProcessAction;

  export function isDomesticAction(action: ReduxAction): action is Action {
    return Object.keys(ActionType).some(k => action.type === ActionType[k as any]);
  }
}

export default AutoSavingAction;
